import { createSlice } from '@reduxjs/toolkit'

export const LogoutSlice = createSlice({
  name: 'logout_session',
  initialState: {
    value: false,
  },
  reducers: {
    logoutSession: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { logoutSession } = LogoutSlice.actions

export default LogoutSlice.reducer